// For error message
import { ERROR_MESSSAGE } from "../../config";

/**
 * Format the search time
 * @param {String} value
 */
function formatSearchTerm(value) {
  // Step 1: Check if value is empty
  if (value.trim() === "") {
    return false;
  }
  // Step 2: Encode the url and return
  return encodeURI(value.trim());
}

/**
 * Action for search
 */
export const actions = {
  /**
   * Send the search request
   * @param {Object} context
   */
  async search(context) {
    // Step 1: Getting the selected provider id
    const selectedProviderId = context.getters.getSelectedProviderID;

    // Step 2: Getting the dates and search term
    const start = context.getters.getStartDate;
    const end = context.getters.getEndDate;
    const searchTerm = formatSearchTerm(context.getters.getSearchValue);

    // Step 3: Check if provider id is set
    if (selectedProviderId === 0 || !searchTerm) {
      if (!searchTerm) {
        // Show error message
        context.dispatch("globalMessagePopup", ERROR_MESSSAGE.search, {
          root: true
        });
      }
      return;
    }

    // Step 4: Do not search if already searching
    if (context.getters.getSearching) {
      return;
    }

    // Step 5: Start searching
    context.commit("startSearching");

    // Step 6: Send get request
    const json = await context.dispatch("makeAuthRequest", {
      url: `appointment/search/${start.dayOfMonth}/${start.month + 1}/${
        start.year
      }/${end.dayOfMonth}/${end.month + 1}/${
        end.year
      }/${searchTerm}/${selectedProviderId}`,
      method: "GET"
    });

    // Step 7: Stop searching and add to the state.
    context.commit("stopSearching");
    context.commit("setResultsForSearch", json.appointments);
  },
  async searchEmail(context) {
    // Step 1: Getting the selected provider id
    const selectedProviderId = context.getters.getSelectedProviderID;

    // Step 2: Getting the dates and search term
    const start = context.getters.getStartDate;
    const end = context.getters.getEndDate;
    const searchTerm = formatSearchTerm(context.getters.getSearchValue);
    const filtertypeAll = context.getters.getFiltertypeAll;
    const filtertypeSubject = context.getters.getFiltertypeSubject;
    const filtertypeSender = context.getters.getFiltertypeSender;
    const filtertypeReceiver = context.getters.getFiltertypeReceiver;

    if(!filtertypeAll && !filtertypeSubject && !filtertypeSender && !filtertypeReceiver) {
      context.dispatch("globalMessagePopup", ERROR_MESSSAGE.searchFilter, {
        root: true
      });

      return;
    }

    // Step 3: Check if provider id is set
    if (selectedProviderId === 0 || !searchTerm) {
      if (!searchTerm) {
        // Show error message
        context.dispatch("globalMessagePopup", ERROR_MESSSAGE.search, {
          root: true
        });
      }
      return;
    }

    // Step 4: Do not search if already searching
    if (context.getters.getSearching) {
      return;
    }

    let appUserId = context.getters['portalemail/getSelectedUserId'];

    // Step 5: Start searching
    context.commit("startSearching");

    // Step 6: Send get request
    const json = await context.dispatch("makeAuthRequest", {
      url: `portalemail/search/${appUserId}/${start.dayOfMonth}/${start.month + 1}/${
        start.year
      }/${end.dayOfMonth}/${end.month + 1}/${
        end.year
      }/${searchTerm}/${selectedProviderId}/${filtertypeAll}/${filtertypeSubject}/${filtertypeSender}/${filtertypeReceiver}`,
      method: "GET"
    });

    // Step 7: Stop searching and add to the state.
    context.commit("stopSearching");
    context.commit("setEmailResultsForSearch", json.searchDetails);
  }
};
